import apiClient from '@/services/axios'
import config from '@/configs'

// staffs functions

// get all staffs
export async function fetchAllStaffs() {
  return apiClient
    .get(`${config.api.system.staffs}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[System/Staffs API]:', err))
}

// get staffs by query
export async function fetchStaffs(query) {
  return apiClient
    .post(`${config.api.system.staffs}/query`, query)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[System/Staffs API]:', err))
}

// get staff by id
export async function fetchStaffById(id) {
  return apiClient
    .get(`${config.api.system.staffs}/${id}`)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[System/Staffs API]:', err))
}

// create a new staff
export async function createStaff(staff) {
  return apiClient
    .post(config.api.system.staffs, staff)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[System/Staffs API]:', err))
}

// update staff
export async function updateStaff(staff) {
  return apiClient
    .put(config.api.system.staffs, staff)
    .then((res) => (res && res.data ? res.data : false))
    .catch((err) => console.error('[System/Staffs API]:', err))
}
